export default {
  "content": "<path d=\"M1 8h12c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z\" fill=\"#3F4450\"/><path d=\"M8 14c.29 0 .57-.12.77-.36l5-6c.31-.37.31-.91 0-1.28l-5-6c-.35-.42-.98-.48-1.41-.13-.42.35-.48.98-.13 1.41L11.7 7l-4.47 5.36A1.001 1.001 0 008 14z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "15",
    "height": "14",
    "viewBox": "0 0 15 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};